import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import { toast } from 'react-toastify';

const {
  joinWebinarFromLinkSaga
} = actions;

class JoinWebinar extends Component {
  constructor(props) {
    super(props);
    this.webinarId = props.params.id;
  }

  componentWillMount = () => {
    this.props.joinWebinar(this.webinarId)
  }

  render() {
    return (
      <main>
        Wait until you will be redirected...
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    joinWebinar: (id) => dispatch(joinWebinarFromLinkSaga(id))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinWebinar);



/** WEBPACK FOOTER **
 ** ./src/containers/JoinWebinar/index.jsx
 **/